import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.button`
  width: 100%;
  height: 60px;
  margin-top: 24px;

  font-family: ${theme.font.inter};
  color: ${(props) => (props.color ? theme.colors.white : theme.colors.green2)};
  line-height: 24px;
  background: ${(props) => (props.color ? theme.colors.green2 : theme.colors.white)};
  border: 2px solid ${theme.colors.green2} !important;
  border-radius: 16px;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  border: none;
  cursor: pointer;

  transition: filter 300ms;

  &:hover {
    filter: brightness(0.6);
  }
`
